<template>
    <div id="InfoSection" v-inview:animate="'fadeIn'">
      <img class="title-img" :src="require('@/assets/images/marketing/info_head.png')"/>
      <img class="title-img" :src="require('@/assets/images/marketing/info_detail.png')"/>
    </div>
</template>

<script>

export default {
  name: 'InfoSection',
}
</script>
<style lang="scss" scoped>
  #InfoSection {
    padding-top: 8.498vh;
    padding-left: 2.82vw;
    padding-right: 2.82vw;
    .title-img {
      padding: 0px;
      margin: 0px;
      display:block;
      width: 100%;
    }
   }
</style>
